'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Panel } from '@/components/ui/panel';
import { Link } from '@/i18n/navigation';
import { WinnerParticipants } from './winner-participants';

/** "About token" panel — short blurb + link back to the original market + the
 *  parent market's participant tally (Figma 3916-2758). */
export function WinnerAboutCard(t0) {
  const $ = _c(26);
  const {
    name,
    marketTitle,
    marketPubkey,
    participantCount,
    className
  } = t0;
  const t = useTranslations("market.winnerDetail");
  let t1;
  if ($[0] !== t) {
    t1 = t("aboutToken");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="text-caption font-medium uppercase tracking-wide text-foreground-secondary">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== marketTitle || $[5] !== name || $[6] !== t) {
    t3 = t("aboutBody", {
      name,
      marketTitle
    });
    $[4] = marketTitle;
    $[5] = name;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <p className="text-body text-foreground-secondary">{t3}</p>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== marketPubkey || $[11] !== participantCount) {
    t5 = <WinnerParticipants marketPubkey={marketPubkey} count={participantCount} />;
    $[10] = marketPubkey;
    $[11] = participantCount;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = `/markets/${marketPubkey}`;
  let t7;
  if ($[13] !== t) {
    t7 = t("viewMarket");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <AnimatedButton asChild={true} variant="secondary" size="lg" className="w-full"><Link href={t6}>{t7}</Link></AnimatedButton>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t4 || $[20] !== t5 || $[21] !== t8) {
    t9 = <div className="flex flex-col gap-3 px-4">{t2}{t4}{t5}{t8}</div>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== className || $[24] !== t9) {
    t10 = <Panel className={className}>{t9}</Panel>;
    $[23] = className;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}